import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var NRDashboardUrlConfig = {
    NRProductData: URLConfig.config.apiBase +
        microService.dashboardService +
        "Lead/NRProductData",
    NRDashboard: URLConfig.config.apiBase + microService.dashboardService + "Lead/NRData",
    PrdoutNRDashboard: URLConfig.config.apiBase + microService.dashboardService + "NR/Product",
    EmployeeNRDashboard: URLConfig.config.apiBase + microService.dashboardService + "NR/Employee",
    HeaderNRDashboard: URLConfig.config.apiBase + microService.dashboardService + "NR/Header",
    ClientLevel: URLConfig.config.apiBase + microService.dashboardService + "NR/ClientLevel",
    Summary: URLConfig.config.apiBase + microService.dashboardService + "NR/Summary",
    Employee: URLConfig.config.apiBase + microService.dashboardService + "NR/Employee",
    Location: URLConfig.config.apiBase + microService.dashboardService + "NR/Location",
    financialYear: URLConfig.config.apiBase + microService.masterSevice + "NR/FinancialYear",
    lobNR: URLConfig.config.apiBase + microService.dashboardService + "NR/LobNR",
};
export default NRDashboardUrlConfig;
